import { AUTO_ATTACHMENT_KEY } from "constants/labels";

/**
 * Just return the first auto attached label
 *
 * @param targetLabels - labels that are attached to the stack, module, blueprint, etc.
 * @param sourceLabels - labels that are attached to the context, policy, etc.
 * @param autoAttachmentKeys - list of auto attachment key prefixes to match against source labels.
 */
export const getAttachedLabel = (
  targetLabels: string[],
  sourceLabels: string[],
  autoAttachmentKeys: string[] = [AUTO_ATTACHMENT_KEY]
) => {
  for (const label of sourceLabels) {
    const matchingKey = autoAttachmentKeys.find((key) => label.startsWith(key));
    if (!matchingKey) continue;

    const [, rest] = label.split(matchingKey);

    // If it's a wildcard label, break here and return it
    if (rest === "*") return label;

    const stackLabel = targetLabels.find((label) => label === rest);

    // If it's a specific label that also was attached to the stack, return it
    if (stackLabel) return label;
  }

  // This should never happen, backend should return contexts that have a matching label
  return "";
};
